<template>
  <div class="pay-center-product">
    <div class="pay-center-product-component">
      <ym-img class="pay-center-product-cover"
              :src="cover"
              :alt="title"
      />
      <div class="pay-center-product-info">
        <div class="pay-center-product-info--top">
          <h1 class="pay-center-product-title ym-two-line-ellipsis">{{ title }}</h1>
          <p v-if="desc !== ''"
             class="pay-center-product-desc"
          >
            {{ desc }}
          </p>
        </div>
        <coin-exchange v-if="coinExchange"
                       :coin="coinExchange.coin"
        />
        <div v-else-if="price && price !== ''"
             class="pay-center-product-price"
        >
          ¥{{ price }}
        </div>
      </div>
    </div>
    <div v-if="coinExchange && coinExchange.exchangeTip !== ''"
         class="pay-center-product-coin-exchange-tip"
    >
      <ym-icon name="aboutus"
      />
      <span>{{ coinExchange.exchangeTip }}</span>
    </div>
    <div v-if="comboList.length !== 0"
         class="pay-center-product-combo-list"
    >
      <div class="pay-center-product-combo-list-block-title">
        本次购买包括以下内容（{{ comboList.length }}）
      </div>
      <div class="pay-center-product-combo-list-product-title"
           v-for="(item, index) in comboList"
           :key="index"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
  import CoinExchange from '@/pages/Pay/components/PayCenterCoinExchange';
  import validator from '@/utils/validator';

  export default {
    name: 'PayCenterProduct',
    components: {
      CoinExchange,
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      cover: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      desc: String,
      price: [Number, String],
      comboList: {
        type: Array,
        required: true,
      },
      coinExchange: {
        type: Object,
        validator(val) {
          return validator.isObject(val);
        },
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .pay-center-product {
    &-component {
      padding: @size-base;
      display: flex;
      align-items: center;
      overflow: hidden;
      background-color: @color-white;
    }

    &-cover {
      overflow: hidden;
      display: block;
      width: 200px;
      height: 150px;
      flex-shrink: 0;
      margin-right: @size-base;
      border-radius: @border-radius-normal;
    }

    &-info {
      align-self: stretch;
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    &-title {
      margin: 0 0 @size-extra-small;
      font-size: @font-size-base;
      font-weight: @font-weight-primary;
    }

    &-desc {
      margin: 0;
      font-size: @font-size-extra-small;
      color: @color-text-light;
      line-height: 1;
    }

    &-price {
      margin-top: @size-extra-small;
      font-size: @font-size-base;
      color: @color-text-lighter;
      line-height: 1;
    }

    &-coin-exchange-tip {
      box-sizing: border-box;
      padding: 0 0 @size-extra-small @size-base;
      display: flex;
      align-items: center;
      color: #ff8500;
      font-size: @font-size-base;
      font-weight: @font-weight-primary;
      line-height: 1;
      background: @color-white;
      .icon {
        margin-right: 4px;
        font-size: @font-size-small;
      }
    }

    &-combo-list {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 0 0 @size-medium @size-base;
      background: @color-white;
      &:before {
        position: absolute;
        top: 0;
        left: @size-base;
        content: '';
        width: 690px;
        height: 1px;
        background: @background-color-base;
      }
    }
    &-combo-list-block-title {
      box-sizing: border-box;
      padding: @size-base 0;
      color: @color-text-base;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      line-height: 1;
    }
    &-combo-list-product-title {
      &:not(:last-child) {
        margin-bottom: @size-small;
      }
      color: @color-text-light;
      font-size: @font-size-base;
      line-height: 1;
    }
  }
</style>
